import { IPageData, IPageParams } from "@/api/types"
import { E_InspectType, E_LineType, IEquipmentItem, IInspectionMappingTaskMappingDetailData } from "./inspection_task.types"
import { E_Axis } from "@/api/moudules/sensor.types"
import { E_AlarmType } from "@/api/enums"

/**
 * 任务类型
 * $t('enum.E_TaskCycleType.EveryDay')
 * $t('enum.E_TaskCycleType.EveryWeek')
 * $t('enum.E_TaskCycleType.EveryMonth')
 */
export enum E_TaskCycleType {
    /**
     * 每天执行
     */
    EveryDay = 1,
    /**
     * 每周执行
     */
    EveryWeek = 2,
    /**
     * 每月执行
     */
    EveryMonth = 3,
}

/**
 * 重复执行标记
 * $t('enum.E_RepeatFlag.Yes')
 * $t('enum.E_RepeatFlag.No')
 */
export enum E_RepeatFlag {
    Yes = 1,
    No = 2,
}

/**
 * 是否巡检
 * $t('enum.E_IsInspect.Yes')
 * $t('enum.E_IsInspect.No')
 */
export enum E_IsInspect {
    Yes = 1,
    No = 2,
}


export interface ITaskPlanEquipmentItem {
    /**
     * 设备ID
     */
    equipmentId: number

    /**
     * 设备名称
     */
    equipmentName: string
    /**
     * 标识编号
     */
    identify: string
    /**
     * 巡检点ID
     */
    inspectPointId: number
    /**
     * 
     */
    isInspect: string
    /**
     * 顺序
     */
    orderNum: number
    /**
     * 备注
     */
    remark: string
    /**
     * 巡检标准ID
     */
    standardId: number
}

// export interface ITaskPlanEquipmentItemDetail extends ITaskPlanEquipmentItem {
//     id: number
//     equipmentName: string
//     inspectPointName: string
//     standardName: string
// }

export interface ICycleConfig {
    weekdays?: number[]
    dayOfMonth?: number
}


export interface ITaskPlanItem {
    /**
     * 总公司ID
     */
    parentCompanyId?: number
    /**
     * 公司ID
     */
    companyId: number
    /**
     * 区域ID
     */
    areaId?: number
    /**
     * 周期配置(JSON格式)
     */
    cycleConfig: ICycleConfig
    /**
     * 任务类型
     */
    cycleType: E_TaskCycleType
    /**
     * 设备列表
     */
    equipmentList: IEquipmentItem[]
    /**
     * 执行时间范围(HH:mm:ss-HH:mm:ss格式)
     */
    executeTime: string
    /**
     * 过期时间
     */
    expireTime?: string
    /**
     * 巡检班组ID
     */
    groupId: number
    /**
     * 巡检闹钟(HH:mm:ss格式)
     */
    inspectClock: string
    /**
     * 巡检顺序类型
     */
    inspectType: E_InspectType
    /**
     * 巡检线路ID
     */
    lineId: number
    /**
     * 路线类型
     */
    lineType: E_LineType
    /**
     * 巡检执行人ID
     */
    operatorId: number
    /**
     * 备注
     */
    remark: string
    /**
     * 重复执行标记
     */
    repeatFlag: E_RepeatFlag
    /**
     * 计划开始时间
     */
    taskBeginTime?: string
    /**
     * 计划结束时间
     */
    taskEndTime?: string
    /**
     * 任务名称
     */
    taskName: string
}


export type IInspectionTaskPlanAddParams = ITaskPlanItem


export interface IInspectionTaskPlanCopyParams {
    id: number
}

export type IInspectionTaskPlanDeleteParams = number[]

export interface IInspectionTaskPlanDetailParams {
    id: number
}
export interface IInspectionTaskPlanDetailData extends ITaskPlanItem {
    companyName
    areaName
    createBy
    createTime
    // equipmentList: ITaskPlanEquipmentItemDetail[]
    groupName: string
    id: number
    lineName: string
    operatorName: number
}

export type IInspectionTaskPlanPageAlarmListParams = IPageParams & Partial<{
    /**
     * 
     */
    alarmType: E_AlarmType
    /**
     * 
     */
    areaId: number
    /**
     * 
     */
    companyId: number
    /**
     * 
     */
    endTime: string
    /**
     * 
     */
    equipmentId: number
    /**
     * 
     */
    mappingId: number
    /**
     * 开始时间
     */
    startTime: string
    /**
     * 任务名称(模糊搜索)
     */
    taskName: number

    /**
     * 任务id
     */
    taskPlanId: number
}>

export interface IInspectionTaskPlanPageAlarmListItem {
    alarmAxis: E_Axis | 'T'
    alarmLevel
    alarmMode
    alarmNo
    alarmType
    alarmValue
    areaId
    areaName
    companyId
    companyName
    createTime
    dealStatus
    equipmentId
    equipmentName
    id
    inspectTaskId
    mappingId
    sensorType
    pointName
    sensorId
    taskName
    thresholdValue
    waveId
    taskPlanId
    vx
    vy
    vz
    tem
}


export type IInspectionTaskPlanPageAlarmListData = IPageData<IInspectionTaskPlanPageAlarmListItem>


export type IInspectionTaskPlanPageListParams = IPageParams & Partial<{
    /**
     * 
     */
    companyId
    /**
     * 
     */
    areaId
    /**
     * 
     */
    cycleType: E_TaskCycleType
    /**
     * 巡检班组ID
     */
    groupId
    /**
     * 巡检执行人ID
     */
    operatorId
    /**
     * 任务名称
     */
    taskName
}>

export interface IInspectionTaskPlanPageItem {
    areaId
    areaName
    companyId
    companyName
    createTime
    cycleConfig: ICycleConfig
    cycleType
    executeTime
    groupId
    groupName
    id
    inspectType
    lineId
    lineName
    lineType
    operatorId
    operatorName
    parentCompanyId
    repeatFlag
    taskBeginTime
    taskEndTime
    taskName
}

export type IInspectionTaskPlanPageListData = IPageData<IInspectionTaskPlanPageItem>

export interface IInspectionTaskPlanUpdateRepeatFlagParams {
    id: number
    repeatFlag: E_RepeatFlag
}


export interface IInspectionTaskPlanUpdateParams extends ITaskPlanItem {
    id: number
}

export interface IInspectionTaskPlanWaveUmlDiagnosisParams {
    /**
     * 诊断轴
     */
    alarmAxis: string //E_Axis
    /**
     * 算法配置Id
     */
    mapTypeList: string[]
    /**
     * 测点Id
     */
    mappingId: number
    /**
     * 转速
     */
    ratedSpeed: number
    /**
     * 波形Id
     */
    waveId: number
}

export interface IInspectionTaskPlanMappingDetailParams {
    mappingId: number
    taskPlanId: number
}
export type IInspectionTaskPlanMappingDetailData = IInspectionMappingTaskMappingDetailData

export interface IInspectionTaskPlanEquipmentsParams {
    taskPlanId: number
}

export interface IInspectionTaskPlanEquipmentsItem {
    equipmentId: number
    equipmentName: string
}

export type IInspectionTaskPlanEquipmentsData = IInspectionTaskPlanEquipmentsItem[]

export interface IInspectionTaskPlanMappingsParams {
    taskPlanId: number
    equipmentId: number
}

export interface IInspectionTaskPlanMappingsItem {
    mappingId: number
    mappingName: string
}

export type IInspectionTaskPlanMappingsData = IInspectionTaskPlanMappingsItem[]
